/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="61.19" height="95.58" viewBox="0 0 61.19 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g>
          <path d="M98,30a1.24,1.24,0,0,1,1.16.8l0,.12,3.07,11.15-2.41.66L97,32.5H58.18L55.37,42.73,53,42.07,56,30.92A1.25,1.25,0,0,1,57.1,30H98Z" transform="translate(-47 -30)" fill="#0e497b"/>
          <path d="M104.74,41.15H50.44a1.25,1.25,0,0,0-1.21.92L47,50.25a1.25,1.25,0,0,0,1.21,1.57h58.69a1.24,1.24,0,0,0,1.2-1.57L106,42.07A1.25,1.25,0,0,0,104.74,41.15Zm-1,2.5,1.53,5.67H49.88l1.52-5.67Z" transform="translate(-47 -30)" fill="#0e497b"/>
        </g><path d="M103,49.32a1.25,1.25,0,0,1,1.25,1.28v.13l-2,15.05-2.48-.32,1.78-13.64h-48L55.4,65.46l-2.48.32L51,50.73a1.25,1.25,0,0,1,1.11-1.4H103Z" transform="translate(-47 -30)" fill="#0e497b"/><path d="M94.65,104.76l2.48.32L94.6,124.49a1.26,1.26,0,0,1-1.12,1.09H61.83a1.24,1.24,0,0,1-1.22-1l0-.13-2.54-19.41,2.48-.32,2.39,18.32H92.26Z" transform="translate(-47 -30)" fill="#0e497b"/><path d="M103,64.37H52.19A1.25,1.25,0,0,0,51,65.76l4.33,39.29a1.25,1.25,0,0,0,1.24,1.12H98.66a1.26,1.26,0,0,0,1.25-1.12l4.33-39.29A1.26,1.26,0,0,0,103,64.37Zm-1.39,2.5-4.06,36.8H57.64l-4-36.8Z" transform="translate(-47 -30)" fill="#ffb81c"/>
      </svg>

    );
  }
}

Icon.displayName = 'CoffeeCupDisposableIcon';

export default Icon;
